import React from 'react';
import { twMerge } from 'tailwind-merge';
import { extractStatusFromProfile } from 'flow/utils';
import {
    selectExtensionActiveProfile,
    selectExtensionStatus,
    selectContact,
} from 'flow/selectors/ExtensionSelectors';
import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import ContactAvatar from 'flow/components/ui-components/ContactAvatar';
import ExtensionName from 'flow/components/ui-components/ExtensionName';

interface Props {
    extensionKey: any;
    itemIsActive: boolean;
    onClick: any;
    index: number;
    className?: string;
}

const ExtensionMentionable = ({
    extensionKey,
    itemIsActive,
    onClick,
    index,
    className,
}: Props) => {
    const { i18next } = useAppContext();

    const status = useAppSelector((state) =>
        selectExtensionStatus(state, extensionKey),
    );
    const contact = useAppSelector((state) =>
        selectContact(state, extensionKey),
    );
    const activeProfile = useAppSelector((state) =>
        selectExtensionActiveProfile(state, extensionKey),
    );

    return (
        <div
            className={twMerge(
                'group flex h-12 w-full cursor-pointer items-center rounded-sm px-3 hover:bg-gray-100',
                itemIsActive ? 'bg-gray-200' : '',
                className,
            )}
            onClick={onClick}
            data-index={index}
        >
            <ContactAvatar
                contact={contact}
                size="medium"
                status={status || 'unknown'}
            />
            <div className="flex flex-col items-center gap-y-0.5 px-2">
                <p className="w-full truncate overflow-hidden text-base/4 whitespace-nowrap">
                    <ExtensionName extensionKey={extensionKey} />
                </p>
                {itemIsActive && (
                    <p className="w-full truncate overflow-hidden text-sm/4 whitespace-nowrap text-gray-500">
                        {extractStatusFromProfile(activeProfile, i18next)}
                    </p>
                )}
            </div>
        </div>
    );
};

export default React.memo(ExtensionMentionable);
